export var START_MARK = "LUX_start";
export var END_MARK = "LUX_end";
export var BOOLEAN_TRUE = "true";
